// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import {useState, useEffect} from 'react';

export const use_was_opened = (opened:boolean)=>{
    const [was_opened, set_was_opened] = useState(opened);
    useEffect(()=>{
        if (opened && !was_opened)
            set_was_opened(true);
    }, [opened]);
    return was_opened;
};
